import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { isSupported } from 'firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { PushNotifications, Token, PushNotificationSchema, ActionPerformed } from '@capacitor/push-notifications';
import { DeviceService } from './device.service';
import { Platform } from '@ionic/angular';

@Injectable({
	providedIn: 'root'
})
export class MessageService {
	private messages$: BehaviorSubject<object>;
	private controller: string = 'message/';

	constructor(
		private api: ApiService,
		public afMessaging: AngularFireMessaging,
		public deviceService: DeviceService,
		public platform: Platform
	) {
		this.messages$ = new BehaviorSubject({});

		if (Capacitor.isNativePlatform()) {
			PushNotifications.addListener('registration', (token: Token) => {
				this.deviceService.create(token.value).subscribe((data) => {});
			});

			// Some issue with our setup and push will not work
			PushNotifications.addListener('registrationError', (error: any) => {
				console.log('Error on registration: ' + JSON.stringify(error));
			});

			// Show us the notification payload if the app is open on our device
			PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
				console.log('pushNotificationReceived', notification);
				this.messages$.next(notification);
			});

			// Method called when tapping on a notification
			PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
				console.log('pushNotificationActionPerformed', notification);
				this.messages$.next(notification.notification);
			});
		}
	}

	start() {
		return new Promise<any>((resolve, reject) => {
			if (!this.platform.is('capacitor')) {
				isSupported().then((data: any) => {
					if (data) {
						this.afMessaging.requestToken.subscribe(
							(token) => {
								this.deviceService.create(token).subscribe(
									(data: any) => {
										this.api.setAuth(data.data);
										this.listen();
										resolve(true);
									},
									() => {
										reject(false);
									}
								);
							},
							(error) => {
								reject(error);
							}
						);
					} else {
						return reject('unsupported');
					}
				});
			} else {
				PushNotifications.requestPermissions().then((result) => {
					if (result.receive === 'granted') {
						// Register with Apple / Google to receive push via APNS/FCM
						PushNotifications.register();
						resolve(true);
					} else {
						reject(false);
						console.log(result.receive);
						// Show some error
					}
				});
			}
		});
	}

	listen() {
		return new Promise<any>((resolve, reject) => {
			this.afMessaging.messages.subscribe(
				(message) => {
					this.messages$.next(message);
					resolve(message);
				},
				(error) => {
					reject(error);
				}
			);
		});
	}

	get() {
		return this.messages$;
	}
}
